import React, { FC, useEffect } from 'react';
import { useGetOtpModalInputRefs, useGetOtpOperationMobileOrEmailOtpModal, useGetOtpOperationSendViaOtpModal, useModalOtpData } from '../../../../../stores/otpModal.store';
import OtpInputs from './OtpInputs';
import { ShieldLock } from 'react-bootstrap-icons';
import useTags from '../../../../../hooks/useTags';
import otpModalLang from '../../../../../data/lang/homePage/otpModal.lang';

type TypeOtpForm = {
    onOtpCodeChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
}

const OtpForm: FC<TypeOtpForm> = ({ onOtpCodeChange }) => {

    const refs = useGetOtpModalInputRefs();
    const inputRef1 = refs[0];
    const { otpStep } = useModalOtpData();
    const mobileOrEmailForGUI = useGetOtpOperationMobileOrEmailOtpModal();
    const sendVia = useGetOtpOperationSendViaOtpModal();

    const generateTag = useTags();
    const otpHelper = generateTag(otpModalLang, `form.otp-helper.${sendVia}`);


    useEffect(() => {

        // Focus the input element when the component mounts
        if (inputRef1.current && otpStep) {
            inputRef1.current.focus();
        }
    }, [otpStep, inputRef1]);


    if (otpStep !== 'otp-input') {
        return null;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <div className='p-4 rounded-circle bg-primary text-white' style={{
                display: 'flex',
                fontSize: '6rem',
                width: '10rem',
                height: '10rem',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'center'
            }}>
                <ShieldLock />
            </div>
            <OtpInputs onOtpCodeChange={onOtpCodeChange} />
            <div className='fst-italic'>{otpHelper}</div>
            <div className='fst-italic' style={{direction: 'ltr'}}>{mobileOrEmailForGUI}</div>

        </div>
    );
}

export default OtpForm